import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {DateUtils} from '../../../utils/date.utils';

@Component({
    selector: 'app-date-interval-filter',
    templateUrl: './date-interval-filter.component.html',
    styleUrls: ['./date-interval-filter.component.scss']
})
export class DateIntervalFilterComponent implements OnInit, OnDestroy {
    @Input() startDateField: string;
    @Input() startDatePlaceholder: string;

    @Input() endDateField: string;
    @Input() endDatePlaceholder: string;

    startDate: Date;
    endDate: Date;
    offset = new Date().getTimezoneOffset() * 60 * 1000;

    unsubscribe$ = new Subject();

    constructor(private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit() {
        this.route.queryParamMap
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(params => {
                this.startDate = this.parseDate(params, this.startDateField);
                this.endDate = this.parseDate(params, this.endDateField);
            });
    }

    parseDate(params, field) {
        if (params.has(field)) {
            const d = new Date(params.get(field));
            return new Date(d.getTime() + this.offset);
        } else {
            return null;
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async startDateChanged() {
        await this.setDate(this.startDate, this.startDateField);
    }

    async endDateChanged() {
        let end = DateUtils.add(this.endDate, 1, 'days');
        end = DateUtils.add(end, -1, 'seconds');
        await this.setDate(end, this.endDateField);
    }

    async setDate(date: Date, dateField: string) {
        console.log(date);
        console.log(date.toISOString());
        date = new Date(date.getTime() - this.offset);
        console.log(date.toISOString());

        const queryParams = {};
        queryParams[dateField] = date.toISOString();
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge'
        });
    }
}
